import type { PresentationModule } from '../../presentation/types';
import { opening, problem, approach } from './content';
import { OpeningScene } from './scenes/OpeningScene';
import { ProblemScene } from './scenes/ProblemScene';
import { ApproachScene } from './scenes/ApproachScene';

export const introModule: PresentationModule = {
  id: 'intro',
  label: 'Introduction',
  priority: 'structural',
  scenes: [
    { ...opening, module: 'intro', create: (resolved) => new OpeningScene(resolved) },
    { ...problem, module: 'intro', create: (resolved) => new ProblemScene(resolved) },
    { ...approach, module: 'intro', create: (resolved) => new ApproachScene(resolved) },
  ],
};
